var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.autorenewModalConfirmOpen
    },
    on: {
      close: _vm.closeModalAutorenewConfirm
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Enabling Auto Renew ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("p", [
              _vm._v(
                "This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active."
              )
            ]),
            _c("p", [_vm._v("Are you sure you want to enable auto renewal?")])
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.closeModalAutorenewConfirm
                }
              },
              [_vm._v("No")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.autorenewLoading
                },
                on: {
                  click: _vm.acceptModalAutorenewConfirm
                }
              },
              [_vm._v("Yes")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }